import { render, staticRenderFns } from "./BarraAvance.vue?vue&type=template&id=32887be8&scoped=true&lang=pug&"
import script from "./BarraAvance.vue?vue&type=script&lang=js&"
export * from "./BarraAvance.vue?vue&type=script&lang=js&"
import style0 from "./BarraAvance.vue?vue&type=style&index=0&id=32887be8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32887be8",
  null
  
)

export default component.exports